import { createContext, useContext, useState } from "react";

const translations = {
  cz: {
    nav: { home: "Domů", news: "Aktuality", concerts: "Koncerty", merch: "Merch", about: "O nás", cart: "Košík", admin: "Admin" },
    hero: { tagline: "Zpíváme. Tancujeme. Rebelujeme.", followUs: "Sleduj nás", upcomingShows: "Nadcházející koncerty" },
    social: { title: "Sleduj nás online", spotify: "Poslouchej na Spotify", youtube: "Sleduj na YouTube", tiktok: "Sleduj na TikTok", followTiktok: "Sledovat na TikToku" },
    concerts: { title: "Koncerty & Akce", subtitle: "Kde nás uvidíš živě", buyTickets: "Koupit lístky", freeEntry: "Vstup volný", viewAll: "Zobrazit vše", noEvents: "Žádné nadcházející koncerty", addToCalendar: "Přidat do kalendáře", map: "Mapa koncertů", list: "Seznam" },
    merch: { title: "Merch", subtitle: "Buď součástí REBELTEAM", buyNow: "Koupit nyní", addToCart: "Přidat do košíku", inStock: "Skladem", outOfStock: "Vyprodáno", viewAll: "Celý obchod", size: "Velikost", quantity: "Množství", featured: "Doporučené" },
    about: { title: "O nás", subtitle: "Jsme Sofi, Agi, Leyla a Naty", story: "Dohromady jsme se daly v září 2023 na konkurzu v karlínském divadle. A pak se to rozjelo. Zpíváme, tancujeme a hrozně nás to baví.", learnMore: "Více o nás", members: "Členky kapely" },
    blog: { title: "Aktuality", subtitle: "Novinky z kapely", readMore: "Číst více", categories: { all: "Vše", concerts: "Koncerty", backstage: "Za scénou", news: "Novinky" } },
    cart: {
      title: "Košík",
      empty: "Váš košík je prázdný",
      emptySub: "Přidejte si něco z našeho merche!",
      total: "Celkem",
      checkout: "K pokladně",
      continueShopping: "Pokračovat v nákupu",
      remove: "Odebrat",
      quantity: "Množství",
      summary: "Shrnutí",
      products: "Produkty",
      shipping: "Doprava",
      shippingFrom: "od",
      unit: "ks",
      decreaseQty: "Snížit množství",
      increaseQty: "Zvýšit množství",
      removeItem: "Odebrat položku",
      seoTitle: "Košík – Oficiální merch kapely Rebelky",
      seoDesc: "Dokonči svou objednávku merchandise oficiální kapely Rebelky. Trička, plakáty, vinyl a další. Rychlé doručení po ČR přes Zásilkovnu.",
      addedToast: "Přidáno do košíku",
      sizeShort: "vel.",
    },
    checkout: {
      title: "Dokončení objednávky",
      name: "Jméno a příjmení",
      email: "E-mail",
      phone: "Telefon",
      address: "Adresa",
      city: "Město",
      zip: "PSČ",
      payment: "Způsob platby",
      bankTransfer: "Bankovní převod",
      cashOnDelivery: "Dobírka",
      note: "Poznámka (nepovinné)",
      submit: "Odeslat objednávku",
      submitting: "Odesílám...",
      orderTotal: "Celkem k úhradě",
      orderSummary: "Shrnutí objednávky",
      shipping: "Doprava",
      pickup: "Osobní odběr",
      packeta: "Zásilkovna",
      free: "ZDARMA",
      cardOnPickup: "Karta na výdejně",
      signatureFor: "Podpis pro",
      signatureHint: "Rebelky vlastnoručně podepíší / napíší vzkaz na fotce nebo na booklet věnovaný komu chceš. Skvělý dárek!",
      signaturePlaceholder: "Komu věnovat? (např. Aničce, ...)",
      consentBefore: "Souhlasím s",
      terms: "obchodními podmínkami",
      consentAnd: "a se",
      privacy: "zpracováním osobních údajů",
      consentAfter: ". Beru na vědomí podmínky",
      delivery: "doručení a platby",
      seoTitle: "Pokladna – Oficiální merch kapely Rebelky",
      seoDesc: "Dokonči objednávku oficiálního merche kapely Rebelky. Platba kartou, QR nebo dobírkou.",
      fieldOk: "Dobře vyplněno",
      fieldHint: "Nápověda",
      nameHint: "Jméno a příjmení příjemce / objednatele",
      emailHint: "Na tento e-mail pošleme potvrzení a odkaz na platbu / PDF",
      emailChecking: "Kontroluji e-mailovou doménu…",
      emailOk: "E-mail v pořádku",
      emailTypo: "Možný překlep — mysleli jste",
      useSuggestion: "Použít",
      phoneHint: "9 číslic bez předvolby — předvolba se doplní sama",
      addressHint: "Ulice a číslo popisné (např. Komenského 12)",
      cityHint: "Město doručení / fakturace",
      zipHint: "PSČ ve formátu 123 45",
      zipOk: "PSČ v pořádku",
      addressOk: "Adresa vypadá v pořádku",
      nameOk: "Jméno v pořádku",
    },
    success: { title: "Objednávka přijata!", subtitle: "Děkujeme za tvou objednávku. Brzy se ti ozveme.", backHome: "Zpět domů", continueShopping: "Pokračovat v nákupu" },
    footer: { contact: "Kontakt", booking: "Booking: Simona Votyová", phone: "777 557 401", production: "Produkce Pinkofein s.r.o.", allRights: "Všechna práva vyhrazena", followUs: "Sleduj nás" },
    common: { loading: "Načítání...", error: "Chyba", save: "Uložit", cancel: "Zrušit", delete: "Smazat", edit: "Upravit", add: "Přidat", close: "Zavřít", search: "Hledat", yes: "Ano", no: "Ne", confirm: "Potvrdit", back: "Zpět", next: "Další", noResults: "Žádné výsledky" },
    admin: { title: "Admin panel", dashboard: "Přehled", events: "Koncerty", posts: "Aktuality", products: "Merch", orders: "Objednávky", settings: "Nastavení", content: "Obsah webu", fanPhotos: "Fan fotky", users: "Admin uživatelé", logout: "Odhlásit se", login: "Přihlásit se", password: "Heslo", loginTitle: "Přihlášení do admin panelu", totalOrders: "Objednávky", newOrders: "Nové", published: "Zveřejněné", drafts: "Koncepty", newsletter: "Newsletter", diagnostics: "Diagnostika", sms: "SMS", cms: "CMS" },
    rebelteam: { title: "REBELTEAM", subtitle: "Sdílej fotky z koncertů a staň se součástí naší rodiny", shareBtn: "Sdílej svoji fotku", yourName: "Tvoje jméno / Instagram handle", caption: "Popisek (nepovinné)", concertLocation: "Kde byla fotka pořízena? (nepovinné)", uploadPhoto: "Nahrát fotku", submit: "Odeslat", cancel: "Zrušit", thanks: "Díky! Tvoje fotka čeká na schválení.", pendingNote: "Po schválení adminem se objeví v srdci níže.", modalHint: "Tvoje fotka projde krátkým schválením adminem a poté se objeví v naší REBELTEAM srdcové mřížce.", noPhotos: "Zatím tady nejsou žádné fotky. Buď první!", uploading: "Nahrávám...", tooLarge: "Soubor je příliš velký (max 8 MB)", photoRequired: "Nejdříve vyber fotku", nameRequired: "Zadej svoje jméno" },
  },
  en: {
    nav: { home: "Home", news: "News", concerts: "Concerts", merch: "Merch", about: "About", cart: "Cart", admin: "Admin" },
    hero: { tagline: "We sing. We dance. We rebel.", followUs: "Follow us", upcomingShows: "Upcoming shows" },
    social: { title: "Follow us online", spotify: "Listen on Spotify", youtube: "Watch on YouTube", tiktok: "Follow on TikTok", followTiktok: "Follow on TikTok" },
    concerts: { title: "Concerts & Events", subtitle: "Where you can see us live", buyTickets: "Buy tickets", freeEntry: "Free entry", viewAll: "View all", noEvents: "No upcoming concerts", addToCalendar: "Add to calendar", map: "Concert map", list: "List" },
    merch: { title: "Merch", subtitle: "Be part of the REBELTEAM", buyNow: "Buy now", addToCart: "Add to cart", inStock: "In stock", outOfStock: "Out of stock", viewAll: "Full shop", size: "Size", quantity: "Quantity", featured: "Featured" },
    about: { title: "About us", subtitle: "We are Sofi, Agi, Leyla and Naty", story: "We came together in September 2023 at an audition at the Karlín Theatre. And then it took off. We sing, we dance and we absolutely love it.", learnMore: "Learn more", members: "Band members" },
    blog: { title: "News", subtitle: "Band updates", readMore: "Read more", categories: { all: "All", concerts: "Concerts", backstage: "Backstage", news: "News" } },
    cart: {
      title: "Cart",
      empty: "Your cart is empty",
      emptySub: "Add something from our merch!",
      total: "Total",
      checkout: "Checkout",
      continueShopping: "Continue shopping",
      remove: "Remove",
      quantity: "Quantity",
      summary: "Summary",
      products: "Products",
      shipping: "Shipping",
      shippingFrom: "from",
      unit: "pcs",
      decreaseQty: "Decrease quantity",
      increaseQty: "Increase quantity",
      removeItem: "Remove item",
      seoTitle: "Cart – Official Rebelky merch",
      seoDesc: "Complete your order of official Rebelky band merchandise. T-shirts, posters, vinyl and more. Fast delivery across Czechia via Packeta.",
      addedToast: "Added to cart",
      sizeShort: "size",
    },
    checkout: {
      title: "Complete your order",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      address: "Address",
      city: "City",
      zip: "ZIP code",
      payment: "Payment method",
      bankTransfer: "Bank transfer",
      cashOnDelivery: "Cash on delivery",
      note: "Note (optional)",
      submit: "Place order",
      submitting: "Sending...",
      orderTotal: "Order total",
      orderSummary: "Order summary",
      shipping: "Shipping",
      pickup: "Store pickup",
      packeta: "Packeta",
      free: "FREE",
      cardOnPickup: "Card at pickup",
      signatureFor: "Signature for",
      signatureHint: "Rebelky will personally sign / write a dedication on a photo or booklet for whoever you choose. A great gift!",
      signaturePlaceholder: "Who is it for? (e.g. Anna, ...)",
      consentBefore: "I agree to the",
      terms: "terms and conditions",
      consentAnd: "and to the",
      privacy: "processing of personal data",
      consentAfter: ". I acknowledge the",
      delivery: "shipping and payment terms",
      seoTitle: "Checkout – Official Rebelky merch",
      seoDesc: "Complete your order of official Rebelky merch. Pay by card, QR or cash on delivery.",
      fieldOk: "Looks good",
      fieldHint: "Help",
      nameHint: "Full name of the recipient / customer",
      emailHint: "We'll send the confirmation and payment / PDF link here",
      emailChecking: "Checking email domain…",
      emailOk: "Email looks good",
      emailTypo: "Possible typo — did you mean",
      useSuggestion: "Use",
      phoneHint: "9 digits without country code — prefix is added automatically",
      addressHint: "Street and house number (e.g. Main Street 12)",
      cityHint: "Delivery / billing city",
      zipHint: "ZIP in format 123 45",
      zipOk: "ZIP looks good",
      addressOk: "Address looks good",
      nameOk: "Name looks good",
    },
    success: { title: "Order received!", subtitle: "Thank you for your order. We'll be in touch soon.", backHome: "Back home", continueShopping: "Continue shopping" },
    footer: { contact: "Contact", booking: "Booking: Simona Votyová", phone: "777 557 401", production: "Pinkofein s.r.o. Production", allRights: "All rights reserved", followUs: "Follow us" },
    common: { loading: "Loading...", error: "Error", save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", add: "Add", close: "Close", search: "Search", yes: "Yes", no: "No", confirm: "Confirm", back: "Back", next: "Next", noResults: "No results" },
    admin: { title: "Admin panel", dashboard: "Dashboard", events: "Events", posts: "News", products: "Merch", orders: "Orders", settings: "Settings", content: "Website content", fanPhotos: "Fan photos", users: "Admin users", logout: "Log out", login: "Log in", password: "Password", loginTitle: "Admin panel login", totalOrders: "Orders", newOrders: "New", published: "Published", drafts: "Drafts", newsletter: "Newsletter", diagnostics: "Diagnostics", sms: "SMS", cms: "CMS" },
    rebelteam: { title: "REBELTEAM", subtitle: "Share your concert photos and become part of our family", shareBtn: "Share your photo", yourName: "Your name / Instagram handle", caption: "Caption (optional)", concertLocation: "Where was the photo taken? (optional)", uploadPhoto: "Upload photo", submit: "Submit", cancel: "Cancel", thanks: "Thanks! Your photo is waiting for approval.", pendingNote: "Once approved by an admin it will appear in the heart below.", modalHint: "Your photo will be briefly reviewed by an admin before it shows up in the REBELTEAM heart.", noPhotos: "No photos yet. Be the first!", uploading: "Uploading...", tooLarge: "File too large (max 8 MB)", photoRequired: "Please choose a photo first", nameRequired: "Please enter your name" },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("cz");
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t, translations }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
